import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DateRangeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"date_range"}/>
}
